import SegmentFilterIcon from './SegmentFilterIcon'
import { SegmentRule } from './types'

interface SegmentFilterProps {
  rule: SegmentRule
  isNegated?: boolean
}

const SegmentFilter = ({ rule, isNegated = false }: SegmentFilterProps) => {
  const isExcluded = isNegated || rule.isExcluded
  const filterClassName = isExcluded
    ? 'thanx-ai-segment-visualization__filter thanx-ai-segment-visualization__filter--excluded'
    : 'thanx-ai-segment-visualization__filter'

  return (
    <div className={filterClassName}>
      <SegmentFilterIcon ruleType={rule.ruleType} />
      <div className="thanx-ai-segment-visualization__filter-content">
        <span className="thanx-ai-segment-visualization__filter-text">
          {rule.display}
        </span>
      </div>
    </div>
  )
}

export default SegmentFilter
